import posthog from 'posthog-js';
import React from 'react';

interface Ibtn {
  btntext: string;
  other?: string;
  isbuttonactive?: boolean;
  clickEvent?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
}
export const CustomButton: React.FC<Ibtn> = (props) => {
  const { btntext, other, isbuttonactive, clickEvent, isLoading } =
    props;
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    // Trigger the PostHog event
    posthog.capture('buttonClicked');
    if (clickEvent) {
      clickEvent(event);
    }
  };
  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={`${
          isbuttonactive ? 'bg-confirmbtn-500' : 'bg-gray-400'
        }  w-32 md:w-36 text-xl rounded-xl h-10 md:h-12 ${other}`}
        disabled={!isbuttonactive}
      >
        <div className=" flex justify-center items-center">
          {isLoading && (
            <span className="animate-spin rounded-full h-5 w-5 border-l-2 border-white inline mr-2">
              {' '}
            </span>
          )}
          <span>{btntext}</span>
        </div>
      </button>
    </>
  );
};
